'use strict';

export default class ListController {

  /*@ngInject*/
  constructor($http) {
    this.$http = $http;
  }

  $onInit() {
    this.getUserManual();
  }

  getUserManual() {
    this.$http.get('/api/UserManuals').then(res => {
      this.manuals = res.data;
    });
  }

  delete(id) {
    if (confirm("确定？")) {
      this.$http.delete(`/api/UserManuals/${id}`).then(res => {
        this.getUserManual();
      });
    }
  }
}



// WEBPACK FOOTER //
// ./client/app/usermanual/list/list.controller.js